// extracted by mini-css-extract-plugin
module.exports = {"comp":"AccessoryA_JP_comp___sCt7"};